<script lang="ts">
  import debounce from "lodash/debounce";
  import { createEventDispatcher } from "svelte";
  import SearchSelect from "./SearchSelect.svelte";
  import { searchCrmContacts, addCrmContact } from "#src/api/crm.js";

  export let border = false;
  export let label = "Label";
  export let labelWidth: string | null = null;
  export let value;
  export let disabled = false;
  export let placeholder = "";
  export let outerBorder = true;
  export let orgid;

  const dispatch = createEventDispatcher();

  $: ssValue = getValue(value);

  // const newContact = {
  //   id: null,
  //   type: "new",
  //   name: "+ Add Contact",
  //   cta: "Click to add new contact",
  //   inputs: [
  //     { label: "Name", type: "text", required: true, prop: "name" },
  //     { label: "Organization", type: "text", prop: "organization" },
  //     { label: "Email", type: "email", required: true, prop: "email" },
  //   ],
  // };

  let searchString = "";
  let results = [];

  function extractZipCodePlus4(addressString) {
    const regex = /\b\d{5}(?:-\d{4})?\b/; // Matches 5 digits, optionally followed by - and 4 digits
    const match = addressString.match(regex);
    return match ? match[0] : null;
  }

  function select(e) {
    const { result } = e.detail;
    let postal_code = null;
    if (result?.organization_details?.address) {
      postal_code = extractZipCodePlus4(result.organization_details.address);
    }

    dispatch("input", {
      contact: {
        id: result.id,
        platform: result.platform,
        name: result.name,
        organization: result.organization,
        email: result.email,
      },
      organization: result.organization_details,
      postal_code,
    });
  }

  function getValue(value) {
    if (!value) return null;
    return {
      id: value.id,
      name: value.name,
      description: value.organization,
      cta: value.email,
      pending: false,
    };
  }

  function deselect() {
    dispatch("input", { contact: null, organization: null, postal_code: null });
  }

  async function add(e) {
    const { result } = e.detail;
    const contact = await addCrmContact(result);
    if (!contact.error) {
      dispatch("input", { contact: contact.data });
    }
  }

  async function fetchContacts() {
    const c = await searchCrmContacts({ search_string: searchString });
    results = c.data.map((contact) => ({
      ...contact,
      description: contact.organization,
      cta: contact.email,
    }));
  }

  const search = debounce(fetchContacts, 500);
</script>

<div class="relative">
  <SearchSelect
    {placeholder}
    {border}
    {outerBorder}
    {labelWidth}
    {label}
    {results}
    selection={ssValue}
    showSelectedDetails
    {disabled}
    bind:value={searchString}
    on:select={select}
    on:add={add}
    on:deselect={deselect}
    on:search={search}
    on:focus={search}>
  </SearchSelect>
</div>
